import moment from 'moment';
import axiosActions from '../axiosHelpers';
import UrlService from '../../../services/UrlService';
import { getSelectedCompany } from '../../selectors';
import { uuidv4 } from '../../../utils/uuid';

export const FETCH_VEHICLE_POSITION_STATISTICS = axiosActions('VEHICLE_POSITION_STATISTICS_LOAD');

const defaultRange = [moment().subtract(1, 'd'), moment()];

export const fetchVehiclePositionStatistics = (
  vehicleId,
  range = defaultRange,
  providingCompanyId = null,
) => (dispatch, getState) => {
  const selectedCompany = getSelectedCompany(getState());
  if (!range || range.length < 2 || !range[0] || !range[1]) {
    return;
  }
  const rangeFrom = range[0].unix();
  const rangeTo = range[1].unix();

  dispatch({
    type: FETCH_VEHICLE_POSITION_STATISTICS.START,
    payload: {
      actionId: uuidv4(),
      request: {
        url: UrlService.vehiclePositionStatistics(vehicleId),
        params: {
          dateFrom: Math.min(rangeFrom, rangeTo),
          dateTo: Math.max(rangeFrom, rangeTo),
          contextCompanyId: selectedCompany,
          providingCompanyId,
        },
      },
    },
  });
};
